import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=578dc5e3&scoped=true"
import script from "./classification.vue?vue&type=script&lang=js"
export * from "./classification.vue?vue&type=script&lang=js"
import style0 from "./classification.vue?vue&type=style&index=0&id=578dc5e3&prod&scoped=true&lang=less"
import style1 from "./classification.vue?vue&type=style&index=1&id=578dc5e3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578dc5e3",
  null
  
)

export default component.exports